// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import DeleteIcon from '../../../../../../assets/images/delete-icon.svg';
import EditIcon from '../../../../../../assets/images/edit-icon.svg';
import SaveIcon from '../../../../../../assets/images/save-icon.svg';

const otherS = {
  Container: styled.div<{ isEdit: boolean, isDeleted:boolean }>`
    display: flex;
    justify-content: space-between;
    min-height: ${props => props.isDeleted ? '44px' : '67px'};
    background-color: ${props => {
      return props.isDeleted ? '#EFEFEF' :
      props.isEdit ? 'rgba(255,245,6,0.5)' : 'rgba(255,245,6,0.2)'
    }};
    padding: 12px;
  `,
  MessageText: styled.textarea`
    flex-grow: 1;
    margin-right: 23px;
    width: 100%;

    font: 16px Noto Sans TC;
    color: #434343;
    overflow: visible;

    background: transparent;
    border: 0px;
    resize: none;

    &:focus {
      outline: none;
      border: 0px;
    }
  `,
  ToolBoxContainer: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  `,
  ToolsContainer: styled.div<{ isEdit: boolean}>`
    display: flex;
    justify-content: ${props => props.isEdit ? 'flex-end' : 'space-between'};
  `,
  DurationText: styled.div`
    font: 16px Noto Sans TC;
    color: #FCA032;
  `,
  EditButton: styled.img.attrs({ src: EditIcon })`
    cursor: pointer;
  `,
  DeleteButton: styled.img.attrs({ src: DeleteIcon })`
    cursor: pointer;
  `,
  SaveButton: styled.img.attrs({ src: SaveIcon })`
    cursor: pointer;
  `,
  DeletedText: styled.div`
    font: 16px Noto Sans TC;
    color: #A6A6A6;
  `,
  RestoreButton: styled.div`
    color: #FE4747;
    text-decoration-line: underline;
    cursor: pointer;
  `
};

export const S = {
  ...otherS
}
